import { pruneUrlFromUnnecessaryCharacters } from '@utility/checkout-utils';

import type { CheckoutApiAccountAccess } from '../../types/CheckoutApiAccountAccess';
import type { GlobalApiAccountAccess } from '../../types/GlobalApiAccountAccess';

export const getAccountAccessRedirectUrls = (
  response: CheckoutApiAccountAccess | GlobalApiAccountAccess | null | undefined
) => {
  const flow = response?.accountAccessFlow;

  if (
    flow?.status === 'PROCESSING' &&
    flow?.details?.reason === 'AWAITING_USER_REDIRECT'
  ) {
    return {
      directUrl:
        pruneUrlFromUnnecessaryCharacters(flow.details.redirect.directUrl) ||
        null,
      proxyUrl:
        pruneUrlFromUnnecessaryCharacters(flow.details.redirect.url) || null,
    };
  }

  return { directUrl: null, proxyUrl: null };
};
